import { Divider } from '@fluentui/react-components'

/**
 * The short vertical rule in an invoice modal's action bar, between Hold and
 * the step's negative action on its left and the forward action on its right
 * (owner, 2026-09-29: "The Hold button should always sit to the left of a
 * small vertical divider to the left of the Approve button, like it already
 * does at AP/AR Approval"). One component, so every bar draws the same rule.
 *
 * `vertical` plus a fixed height rather than `stretch`, since each bar's
 * `alignItems: center` gives every child its own content height and there is
 * no row height to stretch to. `flexGrow: 0` IS LOAD-BEARING: Fluent's Divider
 * base style sets `flex-grow: 1` and the `vertical` variant does not reset it,
 * so without this the rule absorbs all the free space on the bar and parks
 * itself in the middle of the gap. `flexShrink: 0` keeps it from collapsing
 * when the bar wraps.
 */
export function ActionDivider() {
  return <Divider vertical style={{ height: '24px', flexGrow: 0, flexShrink: 0 }} />
}
